import { Box, Stack, Typography } from "@mui/material";
import user from "../../../asset/images/profile_2.png";
import auction from "../../../asset/images/auction.png";
import like from "../../../asset/images/deal_1.png";
import second from "../../../asset/images/second.png";
import first from "../../../asset/images/first.png";
import third from "../../../asset/images/third.png";

export default function HowRegister({text}){
    const steps = [
      { number: first, icon: user, title: text.howReg.firstTitle, body: text.howReg.firstSub, alt: "user" },
      { number: second, icon: auction, title: text.howReg.secondTitle, body: text.howReg.secondSub, alt: "auction" },
      { number: third, icon: like, title: text.howReg.thirdTitle, body: text.howReg.thirdSub, alt: "like" },
    ];

    return (
      <Box
        component="section"
        sx={{
          my: { xs: 4, md: 7 },
          p: { xs: 2.2, sm: 3, md: 4 },
          borderRadius: { xs: "24px", md: "30px" },
          background: "linear-gradient(145deg, #f4f9fd 0%, #edf6fc 100%)",
          border: "1px solid #dceaf5",
        }}
      >
        <Typography
          component="h2"
          sx={{
            mb: 3.5,
            fontFamily: "Assistant",
            fontWeight: 800,
            textAlign: "center",
            color: "#173c5d",
            fontSize: { xs: "1.75rem", md: "2.3rem" },
          }}
        >
          איך זה בדיוק עובד?
        </Typography>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2.5}>
          {steps.map((step) => (
            <Box
              key={step.title}
              sx={{
                flex: 1,
                minWidth: 0,
                p: { xs: 2.2, md: 2.6 },
                bgcolor: "#fff",
                borderRadius: "20px",
                border: "1px solid #e2ebf2",
                boxShadow: "0 12px 30px rgba(22, 70, 108, .08)",
              }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.5}>
                <Box
                  sx={{
                    width: { xs: 58, md: 64 },
                    height: { xs: 58, md: 64 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box component="img" src={step.number} alt="" sx={{ width: "100%", height: "100%", objectFit: "contain" }} />
                </Box>
                <Box
                  sx={{
                    width: { xs: 96, sm: 104, md: 112 },
                    height: { xs: 96, sm: 104, md: 112 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "24px",
                    overflow: "hidden",
                    background: "linear-gradient(145deg, #f4faff 0%, #eaf5fc 100%)",
                    border: "1px solid #d9eaf6",
                    boxShadow: "0 8px 20px rgba(31, 104, 158, .10)",
                    flexShrink: 0,
                  }}
                >
                  <Box
                    component="img"
                    src={step.icon}
                    alt={step.alt}
                    sx={{ width: { xs: 80, sm: 86, md: 92 }, height: { xs: 80, sm: 86, md: 92 }, objectFit: "contain", transform: "scale(1.12)", transformOrigin: "center" }}
                  />
                </Box>
              </Stack>
              <Typography
                component="h3"
                sx={{
                  mt: 2,
                  mb: 1,
                  fontFamily: "Assistant",
                  fontSize: { xs: "1.3rem", md: "1.45rem" },
                  fontWeight: 800,
                  color: "#19476c",
                }}
              >
                {step.title}
              </Typography>
              <Typography
                component="p"
                sx={{
                  m: 0,
                  fontFamily: "Assistant",
                  fontSize: { xs: "1rem", md: "1.06rem" },
                  lineHeight: 1.75,
                  color: "#526d82",
                }}
              >
                {step.body}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    );
}
